import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import FormPage from "./FormPage";
import StatementPage from "./StatementPage";

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FormPage/>} />
          <Route path="statement/:statementId" element={<StatementPage/>} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
